import React, { useEffect, useState, memo } from 'react'

import Header from '../../components/Header'
import ClockComponent from './ClockComponent'
import RoundComponent from './RoundComponent'
import RosterDetail from './RosterDetail'
import TableComponent from './TableComponent'

import { getDraftCounter, getDraftRound } from '../../redux/actions/draftAction'
import { getLeagueDetails } from '../../redux'
import Loader from '../../components/Loader'
import { useSelector } from 'react-redux'

// import { io } from 'socket.io-client'
// import { base_url } from '../../config/constants'

const Draft = () => {
  const { socket } = useSelector((state) => state.socket)
  const [loading, setLoading] = useState(true)
  // const socket = io(base_url)

  useEffect(() => {
    getData()
  }, [])

  const getData = async () => {
    !loading && setLoading(true)
    await getLeagueDetails()
    await getDraftRound(true)
    setLoading(false)
  }

  useEffect(() => {
    console.log('useEffect calling', socket)
    // const token = localStorage.getItem('token')
    if (socket) {
      const handleDraftLive = async (data) => {
        console.log('Draft Live==================>', data)
        await getLeagueDetails()
        await getDraftCounter()
      }

      socket.on('draftLive', handleDraftLive)

      return () => {
        socket.off('draftLive', handleDraftLive)
      }
    }
  }, [socket])

  return (
    <>
      <Header />
      <div className='main_draft_container'>
        {loading ? (
          <Loader />
        ) : (
          <>
            <div className='main_d_left'>
              <ClockComponent />
              <RoundComponent height={'485px'} />
            </div>
            <div className='main_d_center'>
              <RosterDetail />
              <TableComponent professionalDraft tableScroll={{ x: 1000, y: 329 }} />
            </div>
          </>
        )}
      </div>
    </>
  )
}

export default memo(Draft)
